import { connectionEntities, defineRule, resolvedConnections } from '../rule.js';

/** E: a cable joins two outputs. */
export const outputToOutput = defineRule(
  'output-to-output',
  'error',
  { en: 'Output connected to output', de: 'Ausgang mit Ausgang verbunden' },
  (data, emit) =>
    resolvedConnections(data)
      .filter(({ from, to }) => from.direction === 'out' && to.direction === 'out')
      .map(({ connection, from, to }) =>
        emit(connectionEntities(connection), { from: from.name, to: to.name }),
      ),
);
